import React, { useEffect, useState } from 'react';
import { adminGetVideo, adminSetVideo } from '../../utils/api';

export default function AdminVideo() {
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const load = () => {
    setLoading(true);
    adminGetVideo()
      .then((r) => {
        const v = r.data.data;
        setVideo(v);
        if (v) setUrl(v.url);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const getEmbedUrl = (raw) => {
    if (!raw) return null;
    const match = raw.match(/(?:v=|youtu\.be\/)([^&?/]+)/);
    return match ? `https://www.youtube.com/embed/${match[1]}` : raw;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!url.trim()) { setError('Введіть URL відео'); return; }
    setSubmitting(true);
    setError('');
    setSuccess('');
    try {
      await adminSetVideo({ url: url.trim() });
      setSuccess('Відео успішно збережено!');
      load();
    } catch (err) {
      setError(err.response?.data?.message || 'Помилка збереження');
    } finally {
      setSubmitting(false);
    }
  };

  const embedUrl = getEmbedUrl(video?.url);

  return (
    <div>
      <div className="admin-header">
        <h1>Відео компанії</h1>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 32, alignItems: 'start' }}>
        <div style={{ background: 'white', borderRadius: 16, padding: 32, boxShadow: 'var(--shadow-sm)' }}>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '1.2rem', color: 'var(--deep-brown)', marginBottom: 24 }}>
            Встановити відео
          </h2>

          <form onSubmit={handleSubmit}>
            <div className="admin-form-group">
              <label>URL відео (YouTube або пряме посилання)</label>
              <input
                type="url"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                placeholder="https://www.youtube.com/watch?v=..."
              />
              <p style={{ fontSize: '0.78rem', color: 'var(--text-light)', marginTop: 6 }}>
                Підтримуються посилання YouTube: youtube.com/watch?v=... або youtu.be/...
              </p>
            </div>
            {error && <p style={{ color: '#dc2626', fontSize: '0.85rem', marginBottom: 12 }}>{error}</p>}
            {success && <p style={{ color: 'var(--green-deep)', fontSize: '0.85rem', marginBottom: 12 }}>{success}</p>}
            <button type="submit" className="admin-btn primary" disabled={submitting} style={{ width: '100%' }}>
              {submitting ? 'Збереження...' : 'Зберегти відео'}
            </button>
          </form>
        </div>

        <div style={{ background: 'white', borderRadius: 16, padding: 32, boxShadow: 'var(--shadow-sm)' }}>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '1.2rem', color: 'var(--deep-brown)', marginBottom: 24 }}>
            Поточне відео
          </h2>
          {loading ? (
            <div className="spinner" />
          ) : embedUrl ? (
            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, borderRadius: 12, overflow: 'hidden' }}>
              <iframe
                src={embedUrl}
                title="Company video preview"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              />
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--text-light)' }}>
              <div style={{ fontSize: '3rem', marginBottom: 12 }}>🎬</div>
              <p>Відео ще не встановлено</p>
            </div>
          )}
          {video && (
            <p style={{ marginTop: 12, fontSize: '0.82rem', color: 'var(--text-light)', wordBreak: 'break-all' }}>
              {video.url}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
